import { render, staticRenderFns } from "./SchoolsType.vue?vue&type=template&id=56bc472c&"
import script from "./SchoolsType.vue?vue&type=script&lang=js&"
export * from "./SchoolsType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports